import { Dictionary } from "../../../util/collection/Dictionary";
import { EventHandler } from "../../../util/event/EventHandler";
/**
 * DialogData.ts
 */
export class DialogData {
    constructor() {
        this.lang = new Dictionary();
        this.buttonLang = new Dictionary();
        this.handlers = new Dictionary();
        this.params = new Dictionary();
        this.timeout = 0;
    }
    setTimeout(timeout) {
        this.timeout = timeout;
    }
    getTimeout() {
        return this.timeout;
    }
    dispose() {
        this.handlers.clear();
        this.lang = null;
    }
    addButtonLang(key, value) {
        this.buttonLang.setValue(key, value);
    }
    addLang(key, value) {
        this.lang.setValue(key, value);
    }
    addParam(key, value) {
        this.params.setValue(key, value);
    }
    hasLang(key) {
        return this.lang.containsKey(key);
    }
    hasButtonLang(key) {
        return this.buttonLang.containsKey(key);
    }
    onConfirm(action, scope) {
        this.onEvent(DialogData.CONFIRM, action, scope);
    }
    onCancel(action, scope) {
        this.onEvent(DialogData.CANCEL, action, scope);
    }
    onEvent(key, action, scope) {
        this.handlers.setValue(key, new EventHandler(action, scope));
    }
    getLang(key) {
        return this.lang.getValue(key);
    }
    getButtonLang(key) {
        return this.buttonLang.getValue(key);
    }
    hasConfirmHandler() {
        return this.hasHandler(DialogData.CONFIRM);
    }
    hasCancelHandler() {
        return this.hasHandler(DialogData.CANCEL);
    }
    hasHandler(key) {
        return this.handlers.containsKey(key);
    }
    getConfirmHandler() {
        return this.getHandler(DialogData.CONFIRM);
    }
    getCancelHandler() {
        return this.getHandler(DialogData.CANCEL);
    }
    getHandler(key) {
        return this.handlers.getValue(key);
    }
    getParam(key) {
        return this.params.getValue(key);
    }
}
DialogData.CONFIRM = "DialogData.CONFIRM";
DialogData.CANCEL = "DialogData.CANCEL";
//# sourceMappingURL=DialogData.js.map